import { eventEmitterService } from '@widgets/shared/services/eventEmitterService'

type AbstractValue = string | number | object

const localStorageChangesEventCode = 'localStorageChanges'

export default class LocalStorageService {
  protected eventEmitterService = eventEmitterService

  public get<T extends AbstractValue>(key: string) {
    const value = window.localStorage.getItem(key)

    if (value === null) {
      return undefined
    }

    return JSON.parse(value) as T
  }

  public set<T extends AbstractValue>(key: string, value: T) {
    window.localStorage.setItem(key, JSON.stringify(value))
    this.eventEmitterService.emit(localStorageChangesEventCode, { key, value })
  }

  public remove(key: string) {
    window.localStorage.removeItem(key)
    this.eventEmitterService.emit(localStorageChangesEventCode, { key, value: undefined })
  }

  public watch<T extends AbstractValue>(key: string, callback: (value: T) => void) {
    return this.eventEmitterService.on<{ key: string; value: T }>(localStorageChangesEventCode, (payload) => {
      if (payload.key === key) {
        callback(payload.value)
      }
    })
  }

  public unwatch(id: string) {
    this.eventEmitterService.remove(id)
  }
}

export const localStorageService = new LocalStorageService()
